export let _id = require.context("../images/Identity", false, /\.(gif|jpg|jpeg|tiff|png)$/i);
export let _packaging = require.context("../images/Packaging", false, /\.(gif|jpg|jpeg|tiff|png)$/i);
export let _print = require.context("../images/Print", false, /\.(gif|jpg|jpeg|tiff|png)$/i);
export let _signage = require.context("../images/Signage", false, /\.(gif|jpg|jpeg|tiff|png)$/i);




